import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import withStyles from 'react-jss'
import { Link } from 'react-router-dom'

const styles = theme => ({
  paginator: {
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  element: {
    display: 'inline-block',
    width: 35,
    height: 35,
    lineHeight: '35px'
  },
  linkElement: {
    backgroundColor: theme.paginationBackgroundColor,
    color: 'white',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: theme.paginationBackgroundHoverColor,
      color: theme.paginationBorderColor,
      cursor: 'pointer',
      textDecoration: 'none'
    },
    '&:focus': {
      textDecoration: 'none'
    }
  },
  selectedElement: {
    backgroundColor: theme.paginationActiveBackgroundHoverColor,
    color: theme.paginationBorderColor
  },
  disabled: {
    backgroundColor: theme.paginationDisabledColor
  }
})

class Paginator extends PureComponent {
  render() {
    const {
      classes,
      nbOfPages,
      indexPage,
      urlTemplate,
      className,
      updatePage
    } = this.props
    const pageActuelle = indexPage + 1
    const elements = []

    for (let i = 1; i <= nbOfPages; i++) {
      if (
        Math.abs(pageActuelle - i) <= 5 ||
        i === 1 ||
        (i < 100 && i % 10 === 0) ||
        (i < 1000 && i % 100 === 0) ||
        (i < 10000 && i % 1000 === 0) ||
        i === nbOfPages
      ) {
        elements.push(
          updatePage ? (
            <span
              key={i}
              onClick={() => updatePage(i - 1)}
              className={`${classes.element} ${classes.linkElement}${
                i === pageActuelle ? ` ${classes.selectedElement}` : ''
              }`}
            >
              {i}
            </span>
          ) : (
            <Link
              key={i}
              to={
                urlTemplate.indexOf(':page') !== -1
                  ? urlTemplate.replace(':page', i)
                  : urlTemplate.replace(`page=${indexPage + 1}`, `page=${i}`)
              }
              className={`${classes.element} ${classes.linkElement}${
                i === pageActuelle ? ` ${classes.selectedElement}` : ''
              }`}
            >
              {i}
            </Link>
          )
        )
      }
    }

    return (
      <div
        className={`${classes.paginator}${className ? ` ${className}` : ''}`}
      >
        {pageActuelle > 1 &&
          (updatePage ? (
            <span
              onClick={() => updatePage(indexPage - 1)}
              className={`${classes.element} ${classes.linkElement}`}
            >
              Préc.
            </span>
          ) : (
            <Link
              to={
                urlTemplate.indexOf(':page') !== -1
                  ? urlTemplate.replace(':page', pageActuelle - 1)
                  : urlTemplate.replace(
                      `page=${pageActuelle}`,
                      `page=${pageActuelle - 1}`
                    )
              }
              className={`${classes.element} ${classes.linkElement}`}
            >
              Préc.
            </Link>
          ))}
        {elements}
        {pageActuelle < nbOfPages &&
          (updatePage ? (
            <span
              onClick={() => updatePage(indexPage + 1)}
              className={`${classes.element} ${classes.linkElement}`}
            >
              Suiv.
            </span>
          ) : (
            <Link
              to={
                urlTemplate.indexOf(':page') !== -1
                  ? urlTemplate.replace(':page', pageActuelle + 1)
                  : urlTemplate.replace(
                      `page=${pageActuelle}`,
                      `page=${pageActuelle + 1}`
                    )
              }
              className={`${classes.element} ${classes.linkElement}`}
            >
              Suiv.
            </Link>
          ))}
      </div>
    )
  }
}

Paginator.propTypes = {
  indexPage: PropTypes.number.isRequired,
  nbOfPages: PropTypes.number.isRequired,
  urlTemplate: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default withStyles(styles)(Paginator)
